import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import styles from './styles.js';

function CircleNumber(props) {
  const { classes, number } = props;

  return <div className={classes.root}>{number}</div>;
}

CircleNumber.propTypes = {
  classes: PropTypes.object.isRequired,
  number: PropTypes.number.isRequired,
};

CircleNumber.defaultProps = {};

export default withStyles(styles)(CircleNumber);
